// extracted by mini-css-extract-plugin
export default {"main":"Info_main__Blc-t","hrline":"Info_hrline__+9r4M"};